




















import {Component, Vue} from 'vue-property-decorator';
import Aside from "@/components/Aside.vue";
import Header from "@/components/Header.vue";
import {Utils} from "@/utils/utils";
import {Apis} from "@/api";


@Component({
  components: {
    Aside,
    Header
  }
})
export default class App extends Vue {
  isLogin = false
  isInitTeam = false
  visible = false


  async beforeCreate() {
    this.isLogin = Utils.isLogin()
    console.log("is login", this.isLogin)


    //没有登录过
    if (!this.isLogin) {
      const code = this.$route.query.code
      //无法获取code
      if (code == undefined) {
        // console.log("无法获取到code,延时x秒后跳转")

        //清除localStorage
        const storage = window.localStorage;
        storage.clear()

        window.location.href = "https://openapi.wps.cn/oauthapi/v2/authorize?appid=AK20210507FUOARL&response_type=code&redirect_uri="+window.location.protocol+"//" + window.location.host + "/&scope=user_info"

      } else {
        //可以得到code
        //发送code，获取token和其他信息
        const response = await Apis.User.getAccessToken(code.toString())
        // console.log("getAccessToken response:",response)
        //如果用户需要完善信息
        //将userID和userName设置到cookies中，方便完善用户信息页面获取
        //注意：记得在完善信息之后消除这两个cookie
        if (response?.data != null) {
          if (response.data.flag != 0) {
            //需要完善信息,设置cookies，跳转到完善界面
            this.$cookies.set("userID", response.data.userID, 60 * 60 * 12); // 12 hour after, expire
            this.$cookies.set("userName", response.data.userName, 60 * 60 * 12);
            this.$router.push({name: "Register"})
          } else {
            //不需要完善信息，直接登录
            Utils.SetUser(response.data as User)

            // 如果用户尚未加入任何部门，跳转到部门初始化页面
            const re = await Apis.Team.numTeam()
            // console.log("numTeam response:",re)

            if (re != null && re.errno === 0) {
              if (re.data["teamNum"] === 0) {
                this.$router.push({name: "initTeam"})

              } else {
                Utils.SetTeamNum(re.data["teamNum"] as TeamNum)//没有登录过，现在登录成功，有部门的情况
                window.location.href = "/" //会触发刷新
              }
            }
          }
        }
      }
    } else {
      //登陆过
      // 如果用户尚未加入任何部门，跳转到部门初始化页面
      const re = await Apis.Team.numTeam()
      // console.log("numTeam response:",re)

      if (re != null && re.errno === 0) {
        if (re.data["teamNum"] === 0) {
          this.$router.push({name: "initTeam"})
        } else {
          Utils.SetTeamNum(re.data["teamNum"] as TeamNum) //登录过，有部门的情况
        }
      }

    }
  }

  public async created() {

    //登录判断逻辑
    //是登录或者注册页面 就退出登录状态
    if (this.$route.name == "Login" || this.$route.name == "Register") {
      console.log("是登录或者注册页面 就退出登录状态")
      Utils.Logout()
    }

    this.isLogin = Utils.isLogin()
    //没有登录并且不在登录注册页面，则跳转到登录界面
    if (!this.isLogin && (this.$route.name != "Login" && this.$route.name != "Register")) {
      console.log("没有登录并且不在登录注册页面，则跳转到登录界面")
      this.$router.push({name: "Login"})
      // window.location.href = "https://openapi.wps.cn/oauthapi/v2/authorize?appid=AK20210507FUOARL&response_type=code&redirect_uri=https://ai-alerter-test.wps.cn/&scope=user_info"

    }

    this.isInitTeam = Utils.isInitTeam()
    if (!this.isInitTeam && (this.$route.name != "initTeam" && this.$route.name != "Login")) { //没有部门并且路由不是initTeam和Login的情况，跳到initTeam
      this.$router.push({name: "initTeam"})
    }

    this.visible = this.isLogin && this.isInitTeam
    console.log("header和aside,isLogin: ", this.isLogin, " ,isInitTeam: ", this.isInitTeam, " visible: ", this.visible)
  }
}
